<template>
    <el-dialog
        class="del-order"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Add"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form ref="addFrom" :model="addFrom" :rules="rules">
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="SPU/SKU"
                            prop="content"
                            size="small"
                        >
                            <el-input
                                type="textarea"
                                v-model="addFrom.content"
                                :autosize="{ minRows: 8, maxRows: 10 }"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="addVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            addFrom: {
                content: "",
            },
            rules: {
                content: [
                    {
                        required: true,
                        message: "Please input Order Num",
                    },
                ],
            },
        };
    },
    methods: {
        closeDialog() {
            this.$refs["addFrom"].clearValidate();
            this.$refs["addFrom"].resetFields();
            this.$emit("update:addVisible", false);
            this.$parent[this.funcName] && this.$parent[this.funcName]();
        },
        save() {
            this.$refs["addFrom"].validate((valid) => {
                if (valid) {
                    cmofferApi
                        .batchCollection(
                            {
                                ...this.addFrom,
                            },
                            "post"
                        )
                        .then((res) => {
                            if (res) {
                                if(res.errcode == 0){
                                    this.$message.success(
                                        this.$i18n.locale == "zh"
                                            ? "删除成功"
                                            : "Success"
                                    );
                                    this.closeDialog();
                                }
                                
                            }
                        });
                }
            });
        },
    },
    props: {
        addVisible: Boolean,
        funcName: String,
    },
    watch: {
        addVisible(val) {},
    },
};
</script>
<style lang="scss" scoped>
.set-private {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
